var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"field-tag flex items-center justify-center font-semibold rounded-full px-2 bg-card-bg shadow w-24 h-12 text-center text-sm leading-snug text-base-content",attrs:{"title":_vm.title},on:{"click":function($event){return _vm.$emit('onClick',$event)}}},[_c('span',{ref:"output"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }